export default "__VITE_ASSET__Cgkn899j__"